import {
  ADD_BOOKING,
  GET_BOOKING_DETAILS,
  GET_BOOKING_LIST,
  REMOVE_ADD_BOOKING
} from "../types";
import strings from "translate/language";
import { errorToast, unAuthorizedError } from "utils/httpClient";
import { showActionSuccessWithMdoc } from "utils/mdocSyncToasts";
import bookingService from "../service/bookingService";

export const getBookingList = (item) => async (dispatch) => {
  try {
    const res = await bookingService.getBookingList(item);
    if (res.data.status === 200) {
      dispatch({
        type: GET_BOOKING_LIST,
        payload: res.data,
      });
    } else {
      dispatch({
        type: GET_BOOKING_LIST,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const getBookingDetails = (item) => async (dispatch) => {
  try {
    const res = await bookingService.getBookingDetails(item);

    if (res.data.status === 200) {
      dispatch({
        type: GET_BOOKING_DETAILS,
        payload: res.data,
      });
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const addBooking = (item) => async (dispatch) => {
  try {
    const res = await bookingService.addBooking(item);

    if (res.data.status === 200) {
      dispatch({
        type: ADD_BOOKING,
        payload: res.data,
      });
      showActionSuccessWithMdoc(res.data.message, res.data.mdoc);
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const removeAddBookingData = () => async (dispatch) => {
  try {
      dispatch({
          type: REMOVE_ADD_BOOKING,
          payload: null,
      });
  } catch (e) {
      dispatch({
          payload: console.log(e),
      });
  }
}